<rask-virkeskop-validation-message
    [entityGuid]="kontraktGuid"
    [messageId]="validationRules">
</rask-virkeskop-validation-message>

@let isReadonly = isReadonly$ | async;

@if (showPrislistaRadioButtons) {
<rask-radiobutton-group
    label="Prislista"
    [formControl]="prislistaFilterControl"
    [raskDisabledControl]="isReadonly"
    [buttons]="prislistaFilterOptions">
</rask-radiobutton-group>
}

<table class="simple-table pristabell" raskTableKeyboardNavigation>
    <thead>
        <tr>
            <th class="pristabell-w-xl">I utskrift</th>
            <th class="pristabell-w-s">Måttslag</th>
            @if (!isU6) {
            <th class="pristabell-w-m">Välj</th>
            }
            @if (!isU6) {
            <th class="pristabell-w-m">
                <div class="d-flex">
                    <span>Prislista</span>
                    <rask-kontrakt-prislista-filter class="ms-auto">
                    </rask-kontrakt-prislista-filter>
                </div>
            </th>
            }
            @if (useAPris) {
            <th class="pristabell-w-s">á-pris</th>
            }@else{
            <th class="pristabell-w-s">S.netto</th>
            }
            @if (!isU6) {
            <th class="pristabell-w-xs">T/A</th>
            }
            <th class="pristabell-w-xs">FSC</th>
            <th class="pristabell-w-xs">PEFC</th>
            @if (viol2) {
            <th class="pristabell-w-m">S.kod</th>
            }
            @if (viol3) {
            <th class="pristabell-w-m">Inm.sort.</th>
            }
            <th class="pristabell-w-xl">Anteckning</th>
        </tr>
    </thead>
    <tbody [formArray]="pristabellFormArray()">
        @for(formGroup of pristabellFormArray().controls; track formGroup.controls.uniqueKey.value; let i = $index){
        @if(pristabell()[i]; as prisrad){
        <tr rask-kontrakt-prisrad
            [prislistaFilter$]="prislistaFilter$"
            [ngClass]="{ 'readOnly': prisrad.autokompletterad || prisrad.extraMattslagsrad }"
            [formGroup]="formGroup"
            [prisRad]="prisrad"
            (rowAction)="onRowAction($event, prisrad, i)">
        </tr>
        }
        }
    </tbody>
</table>

@if(!isReadonly) {
<div class="mt-3">
    <rask-button
        class="p-0"
        color="secondary"
        (click)="onUpdate()">
        Uppdatera pristabell
    </rask-button>
</div>
}